export enum ActionConstants {
	LOGIN = 'login',
	LOGOUT = 'logout',
	UPDATE_USER_DATA = 'auth_update_user_data',
}
